import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { serverInfo } from "../../../../../../App";

const CategoryContentMap = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);

  const [subCatList, setSubCatlist] = useState();

  const { slug } = useParams();

  useEffect(() => {
    axios.get(`/api/user/left/subcategory/${slug}`).then((res) => {
      if (res.status === 200) {
        setSubCatlist(res.data.selectedSubCategory);
      }
    });
  }, []);

  return (
    <>
      <div className="col-sm-6 col-md-6 col-lg-4 mb-3">
        <div className="card p-2 category-card">
          <img
            src={imageCdnUrl + props?.singleData?.image}
            className="ImgCat"
            alt={imageCdnUrl + props?.singleData?.image}
            height="220px"
          />

          <Link to={`/category-profile/${props.singleData.slug}`}>
            <div className="CatBgS ">
              <h6 className="centeredASd fw-bold">{props.singleData.name}</h6>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default CategoryContentMap;
